import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "detail-item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Student Time Commitment: ", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Purpose:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tandem_select = _resolveComponent("tandem-select")!
  const _component_tandem_date_input = _resolveComponent("tandem-date-input")!
  const _component_planner_event_card = _resolveComponent("planner-event-card")!

  return (_openBlock(), _createBlock(_component_planner_event_card, { event: _ctx.calendarEvent }, {
    dates: _withCtx(() => [
      (_ctx.choicesAreAvailable)
        ? (_openBlock(), _createBlock(_component_tandem_select, {
            key: 0,
            label: "Assignment Type",
            options: _ctx.assignmentOptions,
            "get-label": _ctx.getAssignmentLabel,
            "get-key": _ctx.getAssignmentKey,
            modelValue: _ctx.selectedAssignment,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAssignment) = $event))
          }, null, 8, ["options", "get-label", "get-key", "modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_tandem_date_input, {
        name: "publish-date",
        label: "Release Date",
        "help-text": "This assignment will release at 6:00AM.",
        defaults: { hour: 6, minute: 0 },
        modelValue: _ctx.publishDate,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.publishDate) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_tandem_date_input, {
        name: "due-date",
        label: "Due Date",
        "help-text": "This assignment will be due at 11:59PM.",
        "min-date": _ctx.publishDate,
        defaults: { hour: 23, minute: 59 },
        modelValue: _ctx.dueDate,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dueDate) = $event))
      }, null, 8, ["min-date", "modelValue"])
    ]),
    description: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.assignment.timeCommitment.time || "Not Available") + " ", 1),
          (_ctx.assignment.timeCommitment.comment)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_ctx.assignment.timeCommitment.comment) + ")", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, [
          _hoisted_5,
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.assignment.purpose || "Not Available"), 1)
        ])
      ])
    ]),
    buttons: _withCtx(() => [
      (_ctx.calendarEvent.extendedProps.deletable)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-cancel",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('remove', _ctx.calendarEvent)))
          }, " Remove "))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "btn btn-burg",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args))),
        disabled: !_ctx.formValid
      }, " Update ", 8, _hoisted_7)
    ]),
    _: 1
  }, 8, ["event"]))
}